import React, { createContext, useState, useContext, useEffect } from "react";
import useWindowSize from "Hooks/useWindowSize";
import { BREAKPOINT_MOBILE } from "Styles/media";
import { useLoading } from "./AppProvider";
import theme from "Styles/theme";
import useZoom from "Hooks/useZoom";

interface HomeContextProps {
	isListClicked: boolean;
	setIsListClicked: React.Dispatch<React.SetStateAction<boolean>>;

	touchId: string;
	setTouchId: React.Dispatch<React.SetStateAction<string>>;
	homeLoaded: HomeLoadedProps;
	setHomeLoaded: React.Dispatch<React.SetStateAction<HomeLoadedProps>>;

	// zoom
	value: number;
	onChange: (e: any) => void;
	setValue: React.Dispatch<React.SetStateAction<number>>;
}

const HomeContext = createContext({} as HomeContextProps);

export interface HomeLoadedProps {
	home: boolean;
	list: boolean;
}

const HomeProvider: React.FC = ({ children }) => {
	const [isListClicked, setIsListClicked] = useState(false);
	const [touchId, setTouchId] = useState("-1");
	const { size } = useWindowSize();
	const [homeLoaded, setHomeLoaded] = useState({ home: false, list: false });
	const { setLoading } = useLoading();
	const { value, onChange, setValue } = useZoom(theme.size.zoom.init);

	useEffect(() => {
		// note : set list view when mobile
		if (size.width !== 0) {
			if (size.width <= BREAKPOINT_MOBILE) {
				setIsListClicked(true);
			} else {
				setIsListClicked(false);
			}
		}
	}, [size]);

	useEffect(() => {
		if (homeLoaded.home && homeLoaded.list) {
			setLoading(false);
		}
	}, [homeLoaded, setLoading]);

	return <HomeContext.Provider value={{ isListClicked, setIsListClicked, touchId, setTouchId, homeLoaded, setHomeLoaded, value, onChange, setValue }}>{children}</HomeContext.Provider>;
};

export const useCameraZoom = () => {
	const { value, onChange, setValue } = useContext(HomeContext);
	return { value, onChange, setValue };
};

export const useIsListClicked = () => {
	const { isListClicked, setIsListClicked } = useContext(HomeContext);
	return { isListClicked, setIsListClicked };
};

export const useTouchId = () => {
	const { touchId, setTouchId } = useContext(HomeContext);
	return { touchId, setTouchId };
};

export const useHomeLoaded = () => {
	const { homeLoaded, setHomeLoaded } = useContext(HomeContext);
	return { homeLoaded, setHomeLoaded };
};

export default HomeProvider;
